import script from "./TableAlmacenista.vue?vue&type=script&setup=true&lang=js"
export * from "./TableAlmacenista.vue?vue&type=script&setup=true&lang=js"

import "./TableAlmacenista.vue?vue&type=style&index=0&id=1b4839c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b4839c4"]])

export default __exports__